import { h, empty } from '../../../../src/shared/components/dom.js';
import { navigate } from '../router.js';

const PANEL_BREAKPOINT = 960;

let backdropEl = null;
let panelEl = null;
let panelBody = null;
let closeButtonEl = null;
let onCloseCb = null;
let currentPath = null;
let escHandler = null;
let resizeHandler = null;

function setBackgroundInert(inert) {
  const main = document.getElementById('lib-root');
  if (!main) return;
  if (inert) {
    main.setAttribute('inert', '');
    main.setAttribute('aria-hidden', 'true');
  } else {
    main.removeAttribute('inert');
    main.removeAttribute('aria-hidden');
  }
}

export function canUsePanel() {
  return window.innerWidth >= PANEL_BREAKPOINT;
}

export function isDetailPanelOpen() {
  return backdropEl != null && backdropEl.classList.contains('open');
}

function ensurePanel() {
  if (backdropEl) return;

  closeButtonEl = h('button', {
    type: 'button',
    class: 'lib-detail-panel-close',
    'aria-label': 'Close',
  }, '×');
  closeButtonEl.addEventListener('click', () => closeDetailPanel());

  panelBody = h('div', { class: 'lib-detail-panel-body' });

  panelEl = h('div', {
    class: 'lib-detail-panel',
    role: 'dialog',
    'aria-modal': 'false',
    'aria-labelledby': 'lib-detail-panel-title',
  },
    h('div', { class: 'lib-detail-panel-header' },
      h('span', {
        id: 'lib-detail-panel-title',
        class: 'visually-hidden',
      }, 'Game details'),
      closeButtonEl,
    ),
    panelBody,
  );

  backdropEl = h('div', {
    class: 'lib-detail-panel-backdrop',
    'aria-hidden': 'true',
  }, panelEl);
  backdropEl.addEventListener('click', (e) => {
    if (e.target === backdropEl) closeDetailPanel();
  });

  panelEl.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="/library/g/"]');
    if (!a) return;
    e.preventDefault();
    const m = a.getAttribute('href').match(/^\/library\/g\/([^/]+)\/([^/]+)/);
    if (!m) return;
    const [, system, slug] = m;
    currentPath = `/library/g/${system}/${slug}`;
    navigate(currentPath, { replace: true, scroll: false });
  });

  document.body.appendChild(backdropEl);
}

export function openDetailPanel(_renderGame) {
  ensurePanel();
  empty(panelBody);
  setBackgroundInert(true);
  backdropEl.removeAttribute('aria-hidden');
  panelEl.setAttribute('aria-modal', 'true');
  backdropEl.classList.add('open');
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(() => closeButtonEl?.focus({ preventScroll: true }));

  escHandler = (e) => {
    if (e.key !== 'Escape') return;
    if (document.querySelector('.lib-atl-modal:not(.hidden)')) return;
    closeDetailPanel();
  };
  document.addEventListener('keydown', escHandler);

  resizeHandler = () => {
    if (window.innerWidth < PANEL_BREAKPOINT && isDetailPanelOpen()) {
      const path = currentPath;
      closeDetailPanel({ skipCallback: true });
      if (path) navigate(path);
    }
  };
  window.addEventListener('resize', resizeHandler);

  return panelBody;
}

export function closeDetailPanel({ skipCallback = false } = {}) {
  if (!backdropEl) return;

  backdropEl.classList.remove('open');
  backdropEl.setAttribute('aria-hidden', 'true');
  panelEl.setAttribute('aria-modal', 'false');
  setBackgroundInert(false);
  document.body.style.overflow = '';

  if (escHandler) {
    document.removeEventListener('keydown', escHandler);
    escHandler = null;
  }
  if (resizeHandler) {
    window.removeEventListener('resize', resizeHandler);
    resizeHandler = null;
  }

  if (!skipCallback && onCloseCb) onCloseCb();
  onCloseCb = null;
  currentPath = null;
}

export function setDetailPanelClose(cb) {
  onCloseCb = cb;
}

export function setDetailPanelPath(path) {
  currentPath = path;
}
